import { useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import { enums } from "./enums";
import { startSettingInvestigation } from "../../../../../store/jaguar/jaguarThunks";
import { useDispatch } from "react-redux";

const hoursOpts = [];
for (let h = 0; h < 24; h++) {
  for (let m = 0; m < 60; m += 30) {
    const hour = h % 12 === 0 ? 12 : h % 12;
    const minutes = m === 0 ? '00' : m;
    const ampm = h < 12 ? 'AM' : 'PM';
    const label = `${hour.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    const value = `${h.toString().padStart(2, '0')}:${minutes}`;
    hoursOpts.push({
      label,
      value
    });
  }
}

export const returnIsValid = (error, triedToSave) => {
  if (!triedToSave) return null;
  if (error) return false;
  return true;
}

export const useConstants = () => {

  const dispatch = useDispatch();
  const [t] = useTranslation("investigation");
  const { email, username } = useSelector((state) => state.auth);
  const jaguarState = useSelector((state) => state.jaguar);
  const theme = useTheme();

  const [state] = useState({
    enums,
    involveds: {
      involvedsKindInfo: {
        "victim": {
          title: t("involved.victim_maybe_plural"),
          color: theme.palette.info.main,
        },
        // "accomplice": { // Comentado temporalmente
        //   title: t("involved.accomplice_maybe_plural"),
        //   color: theme.palette.blueGray600.main,
        // },
        "offender": {
          title: t("involved.offender_maybe_plural"),
          color: theme.palette.red.main,
        },
        "witness": {
          title: t("involved.witness_maybe_plural"),
          color: theme.palette.success.main,
        },
      },
      involvedTypeOpts: [
        // { // Comentado temporalmente
        //   value: "accomplice",
        //   label: t("involved.accomplice"),
        // },
        {
          value: "offender",
          label: t("involved.offender"),
        },
        {
          value: "victim",
          label: t("involved.victim"),
        },
        {
          value: "witness",
          label: t("involved.witness"),
        },
      ],
      indicatedOpts: [
        {
          value: "complainant",
          label: t("General.complainant"),
        },
        {
          value: "reviewer",
          label: t("General.reviewer"),
        },
      ],
      colaboratorOpts: [
        {
          value: "external",
          label: t("involved.external"),
        },
        {
          value: "internal",
          label: t("involved.internal"),
        },
      ],
      statusOpts: [
        {
          value: "pending",
          label: t("involved.pending_confirmation"),
        },
        {
          value: "confirmed",
          label: t("involved.confirmed"),
        },
        {
          value: "out",
          label: t("involved.not_participated"),
        },
        {
          value: "cant_confirm",
          label: t("involved.cant_confirmed"),
        },
      ],
      genderOpts: [
        {
          value: "male",
          label: t("involved.male"),
        },
        {
          value: "female",
          label: t("involved.female"),
        },
        {
          value: "other",
          label: t("involved.other"),
        }
      ],
      reinsidenceOpts: [
        {
          value: "yes",
          label: t("involved.yes"),
        },
        {
          value: "no",
          label: t("involved.no"),
        },
      ],
    },
    resources: {
      accessResourcesOpts: [
        {
          value: "access_to_cameras",
          label: t("resources.access_to_cameras"),
        },
        {
          value: "access_to_documents",
          label: t("resources.access_to_documents"),
        },
        {
          value: "access_to_specific_instalations",
          label: t("resources.access_to_specific_instalations"),
        },
        {
          value: "access_to_internet",
          label: t("resources.access_to_internet"),
        },
        {
          value: "access_to_make_inventories",
          label: t("resources.access_to_make_inventories"),
        },
        {
          value: "access_to_computer_systems",
          label: t("resources.access_to_computer_systems"),
        },
        {
          value: "offices_usage",
          label: t("resources.offices_usage"),
        },
        {
          value: "meeting_room_usage",
          label: t("resources.meeting_room_usage"),
        },
        {
          value: "other",
          label: t("resources.other"),
        },
      ],
      expertiseOpts: [
        {
          value: "auditor",
          label: t("resources.auditor"),
        },
        {
          value: "consultant",
          label: t("resources.consultant"),
        },
        {
          value: "finance",
          label: t("resources.finance"),
        },
        {
          value: "manager",
          label: t("resources.manager"),
        },
        {
          value: "graphologist",
          label: t("resources.graphologist"),
        },
        {
          value: "infiltrate",
          label: t("resources.infiltrate"),
        },
        {
          value: "computer_forensics",
          label: t("resources.computer_forensics"),
        },
        {
          value: "investigación",
          label: t("resources.investigación"),
        },
        {
          value: "proficient",
          label: t("resources.proficient"),
        },
        {
          value: "polygraphist",
          label: t("resources.polygraphist"),
        },
      ],
      collaboratorOpts: [
        {
          value: "internal",
          label: t("resources.internal"),
        },
        {
          value: "external",
          label: t("resources.external"),
        },
      ],
      roles: {
        evidence_analysis: t("resources.evidence_analysis"),
        interview_support: t("resources.interview_support"),
        research_approval: t("resources.research_approval"),
        research_advisor: t("resources.research_advisor"),
        data_entry: t("resources.data_entry"),
        evidence_custody: t("resources.evidence_custody"),
        interview_design: t("resources.interview_design"),
        interview_execution: t("resources.interview_execution"),
        evidence_facilitator: t("resources.evidence_facilitator"),
        research_report: t("resources.research_report"),
        research_plan: t("resources.research_plan"),
        research_resources: t("resources.research_resources"),
        research_manager: t("resources.research_manager"),
        interview_witness: t("resources.interview_witness"),
        translator: t("resources.translator"),
        other_research_activities: t("resources.other_research_activities"),
      },
      resourceTypeOpts: [
        {
          value: "access",
          label: t("resources.access_resource"),
        },
        {
          value: "financial",
          label: t("resources.financial_resource"),
        },
        {
          value: "human",
          label: t("resources.human_resource"),
        },
        {
          value: "material",
          label: t("resources.material_resource"),
        },
      ],
    },
    interviews: {
      typeInterviewOpts: [
        {
          label: t("Interview.in_person"),
          value: "in-person",
        },
        {
          label: t("Interview.videocall"),
          value: "video-conference",
        },
      ],
    
      statusOpts: [
        {
          value: "pending",
          label: t("Pendiente"),
        },
        {
          value: "process",
          label: t("En proceso"),
        },
        {
          value: "finish",
          label: t("Finalizada"),
        },
      ],
    
      rolesOpts: [
        {
          label: t("Responsable Investigación"),
          value: "investigation_responsable"
        },
        {
          label: t("Plan de investigación"),
          value: "investigation_plan"
        },
        {
          label: t("Recursos de la investigación"),
          value: "investigation_resources"
        },
        {
          label: t("Diseño de entrevistas"),
          value: "interview_design"
        },
        {
          label: t("Ejecución de entrevistas"),
          value: "interview_executor"
        },
        {
          label: t("Testigo de entrevista"),
          value: "interview_witness"
        },
        {
          label: t("Apoyo de entrevista"),
          value: "interview_help"
        },
        {
          label: t("Traductor"),
          value: "translator"
        },
        {
          label: t("Capturista"),
          value: "data_entry_operator"
        },
        {
          label: t("Facilitador de evidencia"),
          value: "evidence_facilitator"
        },
        {
          label: t("Custodia de evidencia"),
          value: "evidence_custody"
        },
        {
          label: t("Análisis de evidencia"),
          value: "evidence_analysis"
        },
        {
          label: t("Asesor de investigación"),
          value: "investigation_advisor"
        },
        {
          label: t("Informe de investigación"),
          value: "investigation_report"
        },
        {
          label: t("Aprobación de investigación"),
          value: "investigation_approve"
        },
        {
          label: t("Otras actividades de investigación"),
          value: "investigation_other"
        },
        // {
        //   value: "helper",
        //   label: t("Apoyo a entrevista"),
        // },
        // {
        //   value: "witness",
        //   label: t("Testigo de entrevista"),
        // },
      ],
    
      typeFileOpts: [
        {
          value: "signed_questions_and_answers",
          label: t("Preguntas y respuestas con firma"),
        },
        {
          value: "interview_consent",
          label: t("Consentimiento de entrevista firmado"),
        },
        {
          value: "recording_consent",
          label: t("Consentimiento de grabación de entrevista firmado"),
        },
        {
          value: "interview_recording",
          label: t("Grabación de entrevista"),
        },
      ],
    
      pointsToEvaluateLabels: {
        directWitness: t("¿Es testigo directo de los hechos?"),
        offenderHistory: t("¿El ofensor / complice tiene antecedentes de comportamiento similar?"),
        intervieweeReputation: t("¿Se tiene información de la reputación del entrevistado?"),
        statementsCoherent: t("¿Sus declaraciones tienen sentido?"),
        supportsInformant: t("¿Sus declaraciones respaldan los hechos narrados por el informante?"),
        cooperativeAttitude: t("¿El entrevistado se mostró cooperativo con el entrevistador?"),
        lyingMotive: t("¿El entrevistado tiene algún motivo para mentir?"),
        evidenceSupport: t("¿Existe evidencia que corrobore sus declaraciones?"),
        objectivesMet: t("¿Se lograron los objetivos de la entrevista?"),
        otherInvolved: t("¿Se encontraron otros posibles involucrados en el caso?"),
      },
    
      connectionProviderOpts: [
        {
          value: "zoom",
          label: t("Zoom"),
        },
        {
          value: "google_meet",
          label: t("Google Meet"),
        },
        {
          value: "teams",
          label: t("Teams"),
        },
        {
          value: "discord",
          label: t("Discord"),
        },
        {
          value: "other",
          label: t("Otro"),
        },
      ],
    
      options: [
        { label: t("Sí"), value: "yes" },
        { label: t("No"), value: "no" },
        { label: t("Sin determinar"), value: "not-defined" },
      ],
    },
    evaluation: {
      priorityOpts: [
        { value: "null", label: t("evaluation.null_priority") },
        { value: "undefined", label: t("evaluation.undefined_priority") },
        { value: "low", label: t("evaluation.low") },
        { value: "medium", label: t("evaluation.medium") },
        { value: "hight", label: t("evaluation.high") },
        { value: "rejected", label: t("evaluation.rejected") },
      ]
    },
    plans: {
      statusOpts: [
        {
          label: t("activityPlan.pending"),
          value: "pending",
        },
        {
          label: t("activityPlan.in_process"),
          value: "process",
        },
        {
          label: t("activityPlan.finished"),
          value: "completed",
        },
      ],
      statusTodosOpts: [
        {
          label: t("activityPlan.pending"),
          value: false,
        },
        {
          label: t("activityPlan.completed"),
          value: true,
        },
      ]
    },
    evidences: {
      kindOpts: [
        {
          label: t("Evidences.physical"),
          value: "fisic",
        },
        {
          label: t("Evidences.digital"),
          value: "digital",
        },
      ],
      fundamentaOpts: [
        {
          label: t("Evidences.yes"),
          value: "yes",
        },
        {
          label: t("Evidences.no"),
          value: "no",
        },
        {
          label: t("Evidences.partially"),
          value: "partially",
        },
      ],
      kindMoveCustodyOpts: [
        { 
          label: t("Evidences.analysis_on_site"),
          value: "income",
        },
        {
          label: t("Evidences.initial_collection"),
          value: "collection",
        },
        {
          label: t("Evidences.transfer"),
          value: "move",
        },
      ]
    },
    selects: {
      hoursOpts,
      typeUserLabels: {
        [enums.typeUser.ME]: t("type_users.ME"),
        [enums.typeUser.COMPLAINANT]: t("type_users.COMPLAINANT"),
        [enums.typeUser.LEADER]: "Lider",
        [enums.typeUser.PEOPLE]: "People",
        [enums.typeUser.INVOLVEDS]: t("type_users.INVOLVEDS"),
        [enums.typeUser.INVOLVEDS_VICTIM]: t("type_users.INVOLVEDS_VICTIM"),
        [enums.typeUser.INVOLVEDS_ACCOMPLICE]: t("type_users.INVOLVEDS_ACCOMPLICE"),
        [enums.typeUser.INVOLVEDS_OFFENDER]: t("type_users.INVOLVEDS_OFFENDER"),
        [enums.typeUser.INVOLVEDS_WITNESS]: t("type_users.INVOLVEDS_WITNESS"),
        [enums.typeUser.RESOURCES]: t("type_users.RESOURCES"),
        [enums.typeUser.EXTERNAL]: t("type_users.EXTERNAL"),
        [enums.typeUser.SYSTEM]: t("type_users.SYSTEM"),
      }
    },
    investigation: {
      allowOnSimple: [
        enums.sections.researchFolder,
        enums.sections.caseEvaluation,
        enums.sections.locations,
        // "reportCauses",
        enums.sections.involveds,
        enums.sections.evidences,
        enums.sections.conclusion,
      ],
    }
  });

  const functions = {
    askUpdateInvestigationRedux: (investigation) => {
      dispatch(startSettingInvestigation(investigation));
    },
    getUserLabel: (user) => {
      if (!user) return null;
      if (typeof user === "string") return user;
      const { id, from } = user;
      // Si el ID coincide con el email del usuario actual, devolver su nombre
      if (email === id) return username || email;
      if (from === enums.typeUser.COMPLAINANT) return t("type_users.COMPLAINANT");
      if (from === enums.typeUser.LEADER) return "Lider";
      if (from === enums.typeUser.PEOPLE) return "People";
      const users = _.get(jaguarState, `${enums.typeUserRoutes[from]}.formatted`);
      if (!users) return t("type_users.user_not_found");
      return users.find(opt => opt.value === id)?.label ?? t("type_users.user_not_found");
    },
    getResourceLabel: (resource) => {
      const resources = _.get(jaguarState, `${enums.typeResourceRoutes[resource.type]}.formatted`);
      if (!resources) return t("type_users.resource_not_found");
      if (resource.type === enums.typeResource.ACCESS) {
        const resourceLabel = resources.find((opt) => opt.value === resource.resource)?.label;
        return state.resources.accessResourcesOpts.find((opt) => opt.value === resourceLabel)?.label || t("type_users.resource_not_found");
      } else {
        return resources.find((opt) => opt.value === resource.resource)?.label || t("type_users.resource_not_found");
      }
    }
  }

  return { ...state, functions };
}
